import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { ACCOUNT_SITES_ACTIONS } from '../actions/account-sites.actions';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { IAccountSite } from '../../../shared/models/account-site.model';

export const ACCOUNT_SITES_STATE_KEY = 'account-sites';

export interface IAccountSitesState {
  sites: EntityState<IAccountSite> & { loading: boolean; error: Error | null };
}

export const accountSitesAdapter: EntityAdapter<IAccountSite> = createEntityAdapter<IAccountSite>({
  selectId: (site) => site.siteId,
  sortComparer: (site1, site2) => site1.siteName.localeCompare(site2.siteName),
});

export const accountSitesInitialState: IAccountSitesState = {
  sites: accountSitesAdapter.getInitialState({ loading: false, error: null }),
};

const _accountSitesState: ActionReducer<IAccountSitesState> = createReducer<IAccountSitesState>(
  accountSitesInitialState,
  on(ACCOUNT_SITES_ACTIONS.getAccountSites, (state) => ({
    ...state,
    sites: { ...state.sites, error: null, loading: true },
  })),
  on(ACCOUNT_SITES_ACTIONS.getAccountSitesSuccess, (state, { payload }) => ({
    ...state,
    sites: accountSitesAdapter.setAll(payload, { ...state.sites, loading: false }),
  })),
  on(ACCOUNT_SITES_ACTIONS.getAccountSitesError, (state, { payload }) => ({
    ...state,
    sites: { ...state.sites, loading: false, error: payload },
  })),
);

export const accountSitesReducer = (state: IAccountSitesState | undefined, action: Action): IAccountSitesState =>
  _accountSitesState(state, action);
